export const SET_STAGING = 'SET_STAGING';
export const SET_HELP_SCREEN_DATA = 'SET_HELP_SCREEN_DATA';
export const SET_ROW_COLOR = 'SET_ROW_COLOR';
